import React from 'react';

import Carousel from 'components/Carousel';
import Headings from 'components/Headings';
import { defaultHomePageHeadingsConfig } from 'components/Headings/helpers';
import PlaylistTile from 'components/Playlists/PlaylistTile';

import { PlaylistForListFragment } from 'graphql/generated/graphql';

import { IntlMsgShape } from 'helpers/consts';

import PlaylistGroupSkeleton from './Skeleton';
import './style.scss';

interface IProps {
  loading: boolean;
  playlists: Array<PlaylistForListFragment>;
  subtitle: string | IntlMsgShape;
  title: string | IntlMsgShape;
  trackingCategory?: string;
}

export const numberOfSkeletonsToShow = 3;
const skeletonPlaceholders = Array.from<PlaylistForListFragment>({
  length: numberOfSkeletonsToShow,
});

const PlaylistGroup = ({
  loading,
  playlists,
  subtitle,
  title,
  trackingCategory,
}: IProps) => {
  return (
    <div className="PlaylistGroup">
      <Headings
        title={title}
        subtitle={subtitle}
        config={defaultHomePageHeadingsConfig}
      />

      <Carousel
        className="PlaylistGroup__carousel"
        slidesPerView="auto"
        spaceBetween={16}
        watchSlidesProgress
      >
        {(loading ? skeletonPlaceholders : playlists).map((playlist, index) => {
          if (loading) {
            return <PlaylistGroupSkeleton key={index} />;
          }

          return (
            <PlaylistTile
              key={index}
              playlist={playlist}
              trackingCategory={trackingCategory || 'group-playlist'}
            />
          );
        })}
      </Carousel>
    </div>
  );
};

export default PlaylistGroup;
